// ----------------------------------
// logger
// ----------------------------------
import React from 'react';
// import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';

const CrossLoggerPlugin = require('cross-logger-plugin');

const logger = new CrossLoggerPlugin(
  `App:${__filename.replace(__dirname, '')}`,
);

class Header extends React.Component {
  static propTypes = {
    context: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    // ----------------------------
    // initializeData
    // ----------------------------
    const { initializeData } = this.props.context;
  }

  render() {
    return <header />;
  }
}

export default Header;
